import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { useCompareContext } from '../../Context';
import { ProductCardApplyNowContainer } from '../ProductCardWithStickyHeader/components/ApplyNow.container';
import { CardAndTitleSkeleton } from './CardAndTitle.skeleton';
import { CommonSkeleton } from './components/CommonSkeleton';
import { SKELETON_APPLY_NOW_ANNOTATION, SKELETON_RATES_AND_FEES } from './constants';
export function StickyHeaderDesktopSkeleton() {
  const $ = _c(16);
  const {
    anyRatesAndFeesOffer
  } = useCompareContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardAndTitleSkeleton additionalContainerProps={{
      sx: {
        display: {
          xs: "none",
          md: "flex"
        }
      }
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "none",
      md: "block"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = anyRatesAndFeesOffer ? "100px" : "80px";
  let t3;
  if ($[2] !== t2) {
    t3 = {
      display: t1,
      minHeight: t2,
      mt: 2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "45px"
    }, _temp];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={t5} data-testid="skeleton-apply-now-container"><CommonSkeleton width="50%" height="1.25rem" /></Box>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      flex: 1,
      mt: 2
    };
    t8 = <CommonSkeleton width="75%" height="1.25rem" data-testid={SKELETON_APPLY_NOW_ANNOTATION} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== anyRatesAndFeesOffer) {
    t9 = anyRatesAndFeesOffer && <CommonSkeleton width="50%" height="1.25rem" data-testid={SKELETON_RATES_AND_FEES} />;
    $[9] = anyRatesAndFeesOffer;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <ProductCardApplyNowContainer containerProps={t4} needsFixedHeight={true}>{t6}<Box sx={t7}>{t8}{t9}</Box></ProductCardApplyNowContainer>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t3) {
    t11 = <>{t0}<Box sx={t3}>{t10}</Box></>;
    $[13] = t10;
    $[14] = t3;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}
function _temp(theme) {
  return {
    border: `1px dashed ${theme.palette.neutral.lighter}`
  };
}